import React, { useEffect, useState } from 'react';
import { Stack, Typography, Box } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import { formatToLocalDateTime } from '../../../utils/dateFormatter';
import { Img } from '../../patients/display/Img';
import { downloadFile } from '../../../api/uploadService';
import { triggerDownload } from '../../../utils/triggerDownload';
import DownloadIcon from '@mui/icons-material/Download';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import { AudioPreview } from '../controls/AudioPreview';
import { bytesToMegaBytes } from "../../../utils/bytestoMegaBytes";
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';

export default function AttachmentView ({ open, onClose, attachment = null }) {
    const [mediaUrl, setMediaUrl] = useState(null);

    const handleClose = () => {
        setMediaUrl(null);
        onClose();
    };

    const handleDownloadButtonClick = async () => {
        const fileData = await downloadFile(attachment.id);
        triggerDownload(fileData, attachment.filename);
    };

    useEffect(() => {
        let url;
        if (open && attachment && (attachment.mimetype.includes('audio/') || attachment.mimetype.includes('video/') || attachment.mimetype.includes('application/pdf'))) {
            downloadFile(attachment.id).then(fileData => {
            const blob = new Blob([fileData], { type: attachment.mimetype });
            url = URL.createObjectURL(blob);
            setMediaUrl(url);
            });
        }
        return () => {
            if (url) URL.revokeObjectURL(url);
        };
    }, [attachment, open]);

    useEffect(() => {
        if (!open) {
            setMediaUrl(null);
        }
    }, [open]);


    if (!attachment) return <></>;

    return (
        <Dialog onClose={handleClose} open={open} disableRestoreFocus>
            <DialogTitle>
                <Typography variant="body1" sx={{ mt: 0 }} noWrap={true}>{attachment.filename}</Typography>
                <Typography variant="body2" sx={{ mt:0, color: 'gray' }}>
                    {bytesToMegaBytes(attachment.size)} MB
                </Typography>
                <Typography variant="body2" sx={{ mt:0, color: 'gray' }}>
                    {formatToLocalDateTime(attachment.createdAt)}
                </Typography>
            </DialogTitle>
            <DialogContent>
                {attachment.mimetype.includes('image/') ? (
                    <Img fileId={attachment.id} />
                ) : attachment.mimetype.includes('audio/') ? (
                    <Box display="flex" flexDirection="column" alignItems="center" width="100%">
                        {mediaUrl ? (
                            <AudioPreview src={mediaUrl} />
                            // <audio controls style={{ width: '100%' }}>
                            //     <source src={mediaUrl} type={attachment.mimetype} />
                            //     Your browser does not support the audio element.
                            // </audio>

                        ) : (
                            <Typography variant="body2" sx={{ color: 'gray' }}>Loading audio preview...</Typography>
                        )}
                    </Box>
                ) : attachment.mimetype.includes('application/pdf') ? (
                    <Box display="flex" flexDirection="column" alignItems="center" width="100%">
                        {mediaUrl ? (
                            <>
                            <PictureAsPdfIcon sx={{ fontSize: 120, color: 'primary.main' }} />
                            <Button
                              fullWidth
                              variant="outlined"
                              color="primary"
                              href={mediaUrl}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              Open PDF
                            </Button>
                            </>
                        ) : (
                            <Typography variant="body2" sx={{ color: 'gray' }}>Loading preview...</Typography>
                        )}
                    </Box>
                ) : attachment.mimetype.includes('video/') ? (
                    <Box display="flex" flexDirection="column" alignItems="center" width="100%">
                        {mediaUrl ? (
                            <video controls style={{ width: '100%', maxHeight: 400 }}>
                                <source src={mediaUrl} type={attachment.mimetype} />
                                Your browser does not support the video element.
                            </video>
                        ) : (
                            <Typography variant="body2" sx={{ color: 'gray' }}>Loading video preview...</Typography>
                        )}
                    </Box>
                ) : (
                    <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center">
                        <InsertDriveFileIcon sx={{ fontSize: 120, color: 'primary.main' }} />
                        <Typography variant="body2" sx={{ color: 'gray' }}>(no preview available)</Typography>
                    </Box>
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={handleDownloadButtonClick}><DownloadIcon /> Download</Button>
                <div style={{flex: '1 0 0'}} />
                <Button onClick={handleClose}>Close</Button>
            </DialogActions>
        </Dialog>
    );
}